import Head from 'next/head'

// hrefs must match whichever @font-face src wins the cascade: design-system
// typography/_base.scss (/fonts/), which _app loads after the legacy fonts.css
// (/_next-public/fonts/). Preloading the losing path fetches a second copy
// instead of priming the render — that's the FOUT this fixes.
export const FontPreload = () => (
  <Head>
    <link
      as='font'
      crossOrigin=''
      href='/fonts/sohne-buch.woff2'
      rel='preload'
      type='font/woff2'
    />
    <link
      as='font'
      crossOrigin=''
      href='/fonts/sohne-halbfett.woff2'
      rel='preload'
      type='font/woff2'
    />
    <link
      as='font'
      crossOrigin=''
      href='/fonts/sohne-schmal-dreiviertelfett.woff2'
      rel='preload'
      type='font/woff2'
    />
  </Head>
)
